import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './components/Home';
import Navigation from './components/Navigation';
import ClinicSearch from './components/ClinicSearch';
import Clinic from './components/Clinic';
import ReactGA from 'react-ga';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            base_name: '',
            apibaseurl: '',
            googlemapsapikey: '',
            base_url: '',
            ga_initialized: false
        };

        this.GA_TrackPageView = this.GA_TrackPageView.bind(this);
        this.GA_TrackEvent = this.GA_TrackEvent.bind(this);
    }

    componentDidMount() {
        let baseapi = this.props.baseapiurl;
        let googlekey = this.props.googlemapskey;
        let base_url = this.props.base_url;
        let base_name = this.props.base_name;
        this.setState({
            base_name: base_name,
            base_url: base_url,
            apibaseurl: baseapi,
            googlemapsapikey: googlekey
        });
    }

    GA_TrackPageView(url) {
        if (!this.state.ga_initialized) {
            ReactGA.initialize(this.props.ga_trackingid)
            this.setState({
                ga_initialized: true
            }, () => this.GA_TrackPageView(url));
        }
        else {
            ReactGA.pageview(url);
        }
    }

    GA_TrackEvent(category, action, label) {
        if (!this.state.ga_initialized) {
            ReactGA.initialize(this.props.ga_trackingid)
            this.setState({
                ga_initialized: true
            }, () => this.GA_TrackEvent(category, action, label));
        }
        else {
            ReactGA.event({
                category: category,
                action: action,
                label:label,
            });
        }
    }

    render() {
        return (      
            <BrowserRouter>
                <Navigation base_url={this.state.base_url} ga_event={this.GA_TrackEvent}/>
                <Switch>
                    <Route path={this.state.base_name + "/Search"} component={() => <Home googleapikey={this.state.googlemapsapikey} base_url={this.state.base_url} ga_pageview={this.GA_TrackPageView} ga_event={this.GA_TrackEvent}/>} />
                    <Route path={this.state.base_name + "/ClinicSearch"} component={() => <ClinicSearch apibaseurl={this.state.apibaseurl} googleapikey={this.state.googlemapsapikey} base_url={this.state.base_url} ga_pageview={this.GA_TrackPageView} ga_event={this.GA_TrackEvent} />} />
                    <Route path={this.state.base_name + "/Clinic"} component={() => <Clinic apibaseurl={this.state.apibaseurl} googleapikey={this.state.googlemapsapikey} base_url={this.state.base_url} ga_pageview={this.GA_TrackPageView} ga_event={this.GA_TrackEvent} />} />
                    <Route component={() => <Home googleapikey={this.state.googlemapsapikey} base_url={this.state.base_url} ga_pageview={this.GA_TrackPageView} ga_event={this.GA_TrackEvent} />} />
                </Switch>
            </BrowserRouter>
        );
    }
}
 
export default App;